import { createUrl } from "@touchtech/web-api-client";

import { getEnvValue } from "@is/utils/env";

const baseUrl = getEnvValue("VITE_INSTORE_CLOUD_SERVICE_URL");

export const createStoresSearchUrl = () =>
  createUrl(baseUrl, "api/registration/stores/search");

export const createStoresSearchFiltersUrl = () =>
  createUrl(baseUrl, "api/registration/stores/search/filters");

export const createStoresRegisterDeviceUrl = () =>
  createUrl(baseUrl, "api/registration/stores/devices/register");
